import Logo from "../../assets/Logo.png";
import UserAvatar from "../components/generic/UserAvatar";
import { User, newUser } from "../types/User";
import { signoutUser } from "../../features/api/userSlice";
import { useAuth } from "../contexts/auth.context";

import React, { useState } from "react";
import { Stack, Box, Button, TextField, Typography } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import ForumIcon from "@mui/icons-material/Forum";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import { useNavigate } from "react-router-dom";

const Home: React.FC = () => {
    const navigate = useNavigate();
    const { user, setUser } = useAuth();
    const [enteredText, setEnteredText] = useState("");

    const handleEnterClick = () => {
        navigate("/solution", { state: { enteredText } });
    };

    type SignoutButtonProps = {
        user: User;
        setUser: React.Dispatch<React.SetStateAction<User>>;
    };

    const SignoutButton: React.FC<SignoutButtonProps> = ({ user, setUser }) => {
        const navigate = useNavigate();

        function handleButton() {
            // sign out
            try {
                signoutUser();
                setUser(newUser());
                console.log(user.id + " signed out");
                navigate("/");
            } catch (error) {
                console.error(error);
            }
        }

        return (
            <Button variant="text" size="small" color="inherit" endIcon={<ExitToAppIcon />} onClick={handleButton}>
                Sign out
            </Button>
        );
    };

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height="100vh"
            paddingTop={10}
            sx={{ bgcolor: "#F9FEFF" }}
        >
            <img src={Logo} alt="Logo" style={{ width: "300px", height: "auto", marginBottom: 10 }} />
            {user.id !== -1 ? (
                <Stack direction="row" alignItems="center" spacing={1} marginBottom={3}>
                    <Typography
                        variant="h6"
                        sx={{ fontFamily: "Georgia", fontWeight: "bold", fontStyle: "italic", color: "secondary.main" }}
                    >
                        Welcome, {user.username}
                    </Typography>
                    <UserAvatar user={user} size={20} />
                </Stack>
            ) : (
                <Typography
                    variant="h5"
                    marginBottom={3}
                    sx={{ fontFamily: "Georgia", fontWeight: "bold", fontStyle: "italic", color: "primary.main" }}
                >
                    Unlock your potential here, where learning and collaboration go hand in hand
                </Typography>
            )}
            <Box display="flex" sx={{ gap: 1, marginLeft: 8, marginBottom: 5 }}>
                <TextField
                    label="Enter your question here"
                    variant="outlined"
                    value={enteredText}
                    onChange={(e) => setEnteredText(e.target.value)}
                    multiline
                    sx={{ width: "80ch" }}
                />
                <Button
                    color="primary"
                    endIcon={<SendIcon />}
                    onClick={handleEnterClick}
                    disabled={enteredText.trim() === ""}
                />
            </Box>
            <Box display="flex" flexDirection="column" gap={2}>
                <Button
                    variant="contained"
                    color="secondary"
                    endIcon={<ForumIcon />}
                    onClick={() => navigate("/forum")}
                >
                    Go to Forum
                </Button>
                {user.id !== -1 ? (
                    <Box display="flex" flexDirection="column" gap={2}>
                        <Button
                            variant="outlined"
                            color="primary"
                            endIcon={<AppRegistrationIcon />}
                            onClick={() => navigate(`/user/${user.id}`)}
                        >
                            My Profile
                        </Button>
                        <SignoutButton user={user} setUser={setUser} />
                    </Box>
                ) : (
                    <Button
                        variant="contained"
                        color="primary"
                        endIcon={<AppRegistrationIcon />}
                        onClick={() => navigate("/signin")}
                    >
                        Sign In
                    </Button>
                )}
            </Box>
        </Box>
    );
};

export default Home;
